import React, { useMemo } from 'react'

import { CaretRight } from '@phosphor-icons/react'
import { Column, Row, Text } from 'Components/UI'
import { DateTime } from 'luxon'
import { NewsItem } from 'Types/emajinAPI'
import Utils from 'Utils'

import PostPreview from './postPreview'
import { Container, ImagePlaceholder, StyledButton } from './styles'

type Props = {
  data?: NewsItem
  onReadMore?: () => void
}

function NewsCard({ data, onReadMore }: Props) {
  const attachmentToPreview = useMemo(
    () => Utils.Attachment.getAcceptableAttachment(data?.attachments)[0],
    [data],
  )

  if (!data) return null

  return (
    <Container>
      {!!attachmentToPreview ? (
        <img alt="" src={attachmentToPreview.url} />
      ) : (
        <ImagePlaceholder />
      )}

      <Column fullWidth grow p={5} spaceBetween>
        <PostPreview description={data.description} title={data.name} />

        <Row alignCenter fullWidth mt={3} spaceBetween>
          <StyledButton onClick={onReadMore}>
            <Text medium screen16>
              Read more
            </Text>

            <CaretRight size={14} weight="bold" />
          </StyledButton>

          <Text disabled regular screen14>
            {DateTime.fromISO(data.createdAt).toFormat('MMM dd, yyyy')}
          </Text>
        </Row>
      </Column>
    </Container>
  )
}

export default NewsCard
